"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("./Tooltip");
exports.default = Tooltip_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/index.js
// module id = 119
// module chunks = 8